module.exports = __webpack_public_path__ + "img/gray_loading_bg.03a86a3e.png";